import { useQuery } from "@tanstack/react-query";
import type { SessionTail } from "@/hooks/useAiConcierge";
import { useTenant } from "@/hooks/useTenant";

export const conciergeTailKey = (tenantId: string, sessionId: string | null) =>
  ["concierge-tail", tenantId, sessionId] as const;

interface Options {
  sessionId: string | null;
  fetchTail: () => Promise<SessionTail | null>;
  /** Poll interval while the page is focused (default 6 s). */
  intervalMs?: number;
}

/**
 * The concierge session transcript as a shared, polled query: the
 * conversation restores its history from it and keeps receiving the team's
 * replies during a human takeover; the inbox's pinned row reads the same cache
 * for its preview line. react-query pauses the interval while the window is
 * not focused, which is the "don't poll a hidden tab" guard.
 */
export function useConciergeTail({ sessionId, fetchTail, intervalMs = 6000 }: Options) {
  const tenant = useTenant();
  return useQuery({
    queryKey: conciergeTailKey(tenant.id, sessionId),
    queryFn: fetchTail,
    enabled: !!sessionId,
    refetchInterval: intervalMs,
    staleTime: 3000,
  });
}
